module.exports = __webpack_public_path__ + "static/img/Jack-Riewoldt.74c278d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Riewoldt.jpg
// module id = fhEq
// module chunks = 0